import { render, staticRenderFns } from "./Roles-Detail.vue?vue&type=template&id=2542b9d3&"
import script from "./Roles-Detail.vue?vue&type=script&lang=js&"
export * from "./Roles-Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports